import AuthManager from "Common/AuthManager";
import { toast } from "Components/DesignSystem/Toast/useToast";
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";
import { RuleSortableColumn, SortType } from "../enums";
let api_base_url = AppSettings.GMS_BACKEND_API_URL;

export const fetchRuleTableData = async (
  industryId: string,
  channelKey: string,
  page: number,
  recordPerPage: number,
  sort_by: RuleSortableColumn,
  sort_order: SortType,
  searchString?: string,
  commit_status?: boolean,
  base_categories?: string[],
  target_categories?: string[]
): Promise<ApiResponse | null> => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      per_page: recordPerPage.toString(),
      sort_by: sort_by.toString(),
      sort_order: sort_order.toString(),
      industry_id: industryId,
      channel_key: channelKey
    });
    if (commit_status !== undefined) params.append('commit_status', commit_status.toString());
    if (searchString) params.append('search_string', searchString);
    if (base_categories && base_categories.length > 0) params.append('base_categories', JSON.stringify(base_categories));
    if (target_categories && target_categories.length > 0) params.append('target_categories', JSON.stringify(target_categories));

    const endpoint = `${api_base_url}rule/list?${params.toString()}`;
    let res = await ServiceWrapper.doGet(
      endpoint,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (!res.errorfound) {
      return res.data as ApiResponse;
    } else return null;
  } catch (error) {
    console.error("Error fetching rules data:", error);
    return null;
  }
};

export const fetchRulesQueue = async (industryId: string) => {
  let res = await ServiceWrapper.doGet(
    `${api_base_url}rule_queue/industry/${industryId}`,
    null,
    null,
    AuthManager.getGmsToken()
  );
  if (res?.data?.done) {
    const localRulesQueue = res?.data?.data;
    return localRulesQueue;
  } else {
    toast.error("Failed to fetch RulesQueue");
    return null;
  }
};


export const deleteRule = async (Uid: string) => {
  try {
    const res = await ServiceWrapper.doDelete(
      `${api_base_url}rule/delete/${Uid}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res?.errorfound) {
      if (res?.data?.done) toast.success("Deleted successfully");
      else toast.info(res?.data?.message);
    } else toast.warning("Delete Unsuccessful");
  } catch (error) {
    toast.warning("Delete Unsuccessful")
    return "Delete Unsuccessful";
  }
};

export const getUserList = async (partyId: number, industryId: number, skip: number, limit: number, search: string = '') => {
  try {
    const res = await ServiceWrapper.doGet(
      `${api_base_url}party/${partyId}/industry/${industryId}/users?limit=${limit}&skip=${skip}&search=${search}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (res?.data?.done)
      return res;
  } catch (error) {
    return null
  }
};

export const transferOwner = async (data: TransferOwnerPayload) => {
  try {
    const res = await ServiceWrapper.doPut(
      `${api_base_url}rule/transfer_ownership`,
      data,
      null,
      AuthManager.getGmsToken()
    );
    if (res?.data?.done)
      return res;
  } catch (error) {
    return null
  }
};

export const rerunRulesForIndustry = async (industryId: string): Promise<any> => {
  try {
    const res = await ServiceWrapper.doPost(
      `${api_base_url}rules/industry/${industryId}/rerun`,
      {},
      null,
      AuthManager.getGmsToken()
    );
    if (!res?.errorfound && res?.data?.done) {
      toast.success(res?.data?.message ?? "Rule rerun started successfully");
      return res.data;
    } else {
      toast.error(res?.data?.message ?? "Failed to start rule rerun");
      return null;
    }
  } catch (error) {
    toast.error("Failed to start rule rerun");
    return null;
  }
};

